module.exports = "<p>bulk-audit-trail works!</p>\n"